import * as actions from './ConsumerOverviewActions';

const initialState = {
  summary: null,
};

const ConsumerOverviewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SUMMARY_SET:
      return { ...state, summary: payload };
    case actions.ERRORS_SET:
      return { ...state, errors: payload };
    default:
      return state;
  }
};

export default ConsumerOverviewReducer;
